import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-sections">
        <div className="footer-section">
          <h5>24/7 Customer Services</h5>
          <ul className="footer-section-list">
            <li className="footer-section-list__item">
              <a href="!#">Contact Us</a>
            </li>
            <li className="footer-section-list__item">
              <a href="!#">FAQs</a>
            </li>
            <li className="footer-section-list__item">
              <a href="!#">Gift Cards</a>
            </li>
            <li className="footer-section-list__item">
              <a href="!#">Gift Packaging</a>
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h5>Shopping Online</h5>
          <ul className="footer-section-list">
            <li className="footer-section-list__item">
              <a href="!#">Delivery</a>
            </li>
            <li className="footer-section-list__item">
              <a href="!#">Track you order</a>
            </li>
            <li className="footer-section-list__item">
              <a href="!#">Returns & Refunds</a>
            </li>
            <li className="footer-section-list__item">
              <a href="!#">Brand Directory</a>
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h5>About Us</h5>
          <ul className="footer-section-list">
            <li className="footer-section-list__item">
              <a href="!#">Careers</a>
            </li>
            <li className="footer-section-list__item">
              <a href="!#">Our heritage</a>
            </li>
            <li className="footer-section-list__item">
              <a href="!#">Sustainability</a>
            </li>
            <li className="footer-section-list__item">
              <a href="!#">Coporate policies</a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
